module.exports = __webpack_public_path__ + "media/images/front/icon_05_arrow2_y-8c3266c6afdc329c7b5053b9f37bf5ce.png";